export default __webpack_public_path__ + "static/media/bed21-512.b319bd27.9e1bf8eb.png";